var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMclarenBannerDeep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2259,
    height: 384,
    viewBox: "0 0 2259 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_1917)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2259,
    height: 384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31_1917)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_1917",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.5879 687.54L777.159 58.466H1268.83L300.33 819.329L-23.5879 818.53V687.54Z",
    fill: "url(#paint0_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.121 625.24H777.566L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5874 513.738L368.856 205.431H748.286L-27.8574 815.176L-23.5874 513.738Z",
    fill: "url(#paint2_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.018 -12.939L160.941 435.703H592.121L1165.49 -14.736L732.018 -12.939Z",
    fill: "url(#paint3_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.5928 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint4_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.799 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.799 -10.224Z",
    fill: "url(#paint5_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.622L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint6_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.8955 412.49H280.975L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint7_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.77 -14.736L1003.48 334.305H1574.65L2000.11 0.060008L1447.77 -14.736Z",
    fill: "url(#paint8_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.47 -12.141L1719.43 535.463H1268.83L1961.1 -8.38699L2416.47 -12.141Z",
    fill: "url(#paint9_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.622 815.176L1425.37 184.527H1883.73L1078.93 816.784L622.622 815.176Z",
    fill: "url(#paint10_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.47 105.102L2086.23 364.547H1649.48L2126.82 -10.455H2416.47V105.102Z",
    fill: "url(#paint11_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.6 -10.455L1381.28 292.257H1903.25L2291.07 -12.418L1766.6 -10.455Z",
    fill: "url(#paint12_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.63 480.511H888.183L1524.97 -19.756H2000.11L1317.63 480.511Z",
    fill: "url(#paint13_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2368.49 -10.455L1771.8 458.305H2248.11L2411.21 330.171L2416.47 -10.455H2368.49Z",
    fill: "url(#paint14_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413.84 159.784L1773.5 662.843H2111.47L2409.3 428.866L2413.84 159.784Z",
    fill: "url(#paint15_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.85 -19.756L691.791 262.326H1158.22L1521.13 -22.778L1050.85 -19.756Z",
    fill: "url(#paint16_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5873 369.04H422.944L-34.4473 728.37L-23.5873 369.04Z",
    fill: "url(#paint17_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.88 -10.455L1086.33 293.221H735.271L1115.67 -5.62599L1472.88 -10.455Z",
    fill: "url(#paint18_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.7305 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint19_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.943 -121.136L-153.013 331.34V-118.652L422.943 -121.136Z",
    fill: "url(#paint20_linear_31_1917)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.6 636.923H1589.9L2469.95 -40.036H2794.4L1917.6 636.923Z",
    fill: "url(#paint21_linear_31_1917)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#F57F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.598 99.9445C274.598 101.478 273.922 102.589 271.828 102.589H258.461C256.738 102.589 255.755 102.091 255.755 100.494C255.755 98.8967 256.431 98.1045 258.461 98.1045H274.598V99.9445ZM333.542 93.5556V91.8306C333.542 90.2333 334.219 89.1856 336.376 89.1856H349.743C351.581 89.1856 352.501 89.735 352.501 91.46C352.501 92.9295 351.773 93.6067 349.871 93.6067L333.542 93.5556ZM368.638 81.7106V109.949H382.158V89.4411H393.188C396.941 89.4411 398.844 90.6167 398.844 94.2328V110.013H412.338V93.1211C412.338 85.1989 407.972 81.7617 395.652 81.7617L368.638 81.7106ZM335.444 81.7106C324.58 81.7106 320.226 85.3267 320.226 93.4917V99.0883C320.226 106.142 324.58 109.949 334.397 109.949H362.931V102.577H337.04C334.487 102.577 333.606 101.836 333.606 99.9317V98.7689H354.033C361.08 98.7689 365.063 96.5583 365.063 91.2811V90.0033C365.063 85.2117 362.676 81.7745 350.713 81.7745L335.444 81.7106ZM292.038 109.949H305.532V91.46C305.532 90.1822 306.03 89.4283 307.69 89.4283H318.12V81.7617H303.119C295.076 81.7617 292.012 84.7645 292.012 89.7989L292.038 109.949ZM245.912 81.7106V89.1472H271.254C273.807 89.1472 274.637 90.0161 274.637 91.8561V92.9422H254.287C245.759 92.9422 243.192 96.4561 243.192 100.928V102.027C243.192 108.237 248.159 109.949 257.912 109.949H272.888C283.497 109.949 288.093 107.56 288.093 99.2033V92.6867C288.093 85.6206 283.739 81.7617 273.871 81.7617L245.912 81.7106ZM165.15 97.4783C165.15 106.423 169.682 110.001 181.402 110.001H207.114V102.334H183.368C180.546 102.334 178.644 101.056 178.644 96.9928V94.5906C178.644 90.9617 180.419 89.4795 183.304 89.4795H207.114V81.8128H181.032C169.542 81.8128 165.15 86.6556 165.15 94.3989V97.4783ZM211.11 77.2767V110.001H240.473V102.334H224.642V77.2767H211.11ZM126.85 95.5745V77.2767H119.19C114.466 77.2767 111.772 79.1678 108.976 81.3911L73 110.001H89.252L113.189 90.6039V110.001H124.411L147.596 90.4761V110.001H161.345V77.2767H153.851C149.804 77.2767 146.983 78.9378 144.161 81.2633L126.85 95.5745Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444.791 53.51C437.258 53.51 426.649 55.7589 415.147 59.9756C404.862 63.7181 395.016 68.5726 385.783 74.4528C394.639 71.1953 403.977 69.4461 413.41 69.2778C426.611 69.2778 436.007 74.3889 422.13 92.0606C462.983 65.2272 461.924 53.5739 444.791 53.5739",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.222 138.278H156.597V140.744H150.877V143.657H155.984V146.136H150.877V151.247H148.222V138.278Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.746 144.884V144.667C166.746 140.757 169.197 138.022 172.644 138.022C176.091 138.022 178.517 140.731 178.517 144.628V144.846C178.517 148.679 176.053 151.49 172.619 151.49C169.185 151.49 166.746 148.768 166.746 144.884ZM175.683 144.884V144.667C175.683 142.111 174.406 140.488 172.58 140.488C170.755 140.488 169.516 142.111 169.516 144.667V144.794C169.516 147.35 170.793 148.986 172.644 148.986C174.495 148.986 175.721 147.376 175.721 144.82L175.683 144.884Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.713 138.278H194.603C195.243 138.247 195.883 138.345 196.486 138.564C197.089 138.783 197.642 139.12 198.113 139.556C198.491 139.958 198.783 140.432 198.971 140.951C199.16 141.469 199.242 142.02 199.211 142.571C199.253 143.381 199.043 144.184 198.611 144.87C198.179 145.556 197.546 146.092 196.798 146.404L199.569 151.234H196.492L194.092 146.954H192.407V151.234H189.7L189.713 138.278ZM194.398 144.667C194.671 144.703 194.948 144.678 195.21 144.595C195.472 144.512 195.713 144.372 195.915 144.186C196.117 143.999 196.276 143.77 196.38 143.516C196.484 143.261 196.531 142.987 196.518 142.712C196.518 141.434 195.713 140.757 194.347 140.757H192.419V144.667H194.398Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.459 138.278H213.28L216.178 143.555L219.051 138.278H221.885V151.26H219.242V142.954L216.178 148.321L213.127 142.993V151.26H210.574L210.459 138.278Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233.516 146.2V138.278H236.222V146.251C236.222 148.091 237.09 148.998 238.482 148.998C239.873 148.998 240.754 148.104 240.754 146.302V138.278H243.423V146.174C243.423 149.765 241.456 151.503 238.444 151.503C235.431 151.503 233.516 149.778 233.516 146.2Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M255.053 138.278H257.747V148.819H263.006V151.298H255.053V138.278Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M277.905 138.176H280.458L285.131 151.26H282.373L281.377 148.5H276.909L275.99 151.26H273.296L277.905 138.176ZM280.56 146.059L279.143 141.817L277.713 146.059H280.56Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M310.983 140.923L309.004 141.459L308.57 139.121L311.736 138.15H313.6V151.26H310.945L310.983 140.923Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.624 140.744H338.355V138.278H347.573V140.833H344.292V151.349H341.624V140.744Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M358.259 138.278H366.634V140.706H360.953V143.517H365.97V145.944H360.953V148.845H366.723V151.286H358.272L358.259 138.278Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M381.749 138.176H384.302L388.962 151.26H386.179L385.234 148.5H380.753L379.808 151.324H377.102L381.749 138.176ZM384.404 146.059L383 141.817L381.57 146.059H384.404Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M399.584 138.278H402.38L405.278 143.555L408.176 138.278H411.023V151.26H408.38V142.954L405.316 148.321L402.265 142.993V151.26H399.635L399.584 138.278Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_1917",
    x1: 900.322,
    y1: 136.714,
    x2: 220.424,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_1917",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.392,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_1917",
    x1: 64.8374,
    y1: 608.483,
    x2: 513.998,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_1917",
    x1: 276.23,
    y1: 500.058,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_31_1917",
    x1: 200.655,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_31_1917",
    x1: -97.0268,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_31_1917",
    x1: -214.998,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_31_1917",
    x1: 20.1713,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_31_1917",
    x1: 1141.98,
    y1: 436.034,
    x2: 1485.93,
    y2: 178.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_31_1917",
    x1: 1393.44,
    y1: 597.841,
    x2: 1823.09,
    y2: 276.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_31_1917",
    x1: 753.282,
    y1: 873.897,
    x2: 1231.38,
    y2: 516.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_31_1917",
    x1: 1757.18,
    y1: 438.419,
    x2: 2046.19,
    y2: 222.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_31_1917",
    x1: 1507.99,
    y1: 385.507,
    x2: 1821.88,
    y2: 150.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_31_1917",
    x1: 1427.62,
    y1: 156.66,
    x2: 1485.59,
    y2: 415.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_31_1917",
    x1: 2089.36,
    y1: 202.623,
    x2: 2145.8,
    y2: 454.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_31_1917",
    x1: 2283.7,
    y1: 204.309,
    x2: 2095.62,
    y2: 538.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_31_1917",
    x1: 1096.28,
    y1: 74.3577,
    x2: 1135.39,
    y2: 248.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_31_1917",
    x1: -34.4471,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_31_1917",
    x1: 1037.07,
    y1: 246.023,
    x2: 1251.65,
    y2: -89.0799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3812,
    stopColor: "#8D1B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_31_1917",
    x1: -52.7469,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3812,
    stopColor: "#8D1B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_31_1917",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3131,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3812,
    stopColor: "#8D1B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_31_1917",
    x1: 2295.31,
    y1: 168.921,
    x2: 2039.11,
    y2: 490.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2259,
    height: 384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_1917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMclarenBannerDeep);
export default __webpack_public_path__ + "static/media/mclaren_banner_deep.aab3524aa05ad8a51c67f467b9490af9.svg";
export { ForwardRef as ReactComponent };